import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link, navigate } from 'raviger';
import { Formik } from 'formik';
import { Button, Card, Col, Collapse, Form as BootstrapForm, ListGroup, Modal, OverlayTrigger, Row, Tooltip, Spinner } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClipboardCheck,
  faClipboardList,
  faUpload,
  faEdit,
  faEnvelope,
  faBriefcaseMedical,
  faMapMarkedAlt,
  faMinusSquare,
  faPlusSquare,
  faPencilAlt,
  faUserPlus,
  faChevronCircleUp,
  faChevronCircleDown,
  faCheckSquare,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { faClockRotateLeft, faExclamationSquare, faChevronDoubleUp, faFileBracketsCurly, faSparkles, faLocationPlus, faLocationPen, faSquareExclamation } from '@fortawesome/pro-solid-svg-icons';
import { faLocationXmark, faCalendarExclamation } from '@fortawesome/pro-regular-svg-icons';
import { Marker, Tooltip as MapTooltip } from "react-leaflet";
import L from "leaflet";
import Moment from 'react-moment';
import Map, { countDictMatches, prettyText, createCheckMarkerIcon, createReportedMarkerIcon, createReportedEvacMarkerIcon, createReportedSIPMarkerIcon, createSIPMarkerIcon, createUTLMarkerIcon, createOperationsMarkerIcon, createReturnRequestedMarkerIcon } from "../components/Map";
import Header from '../components/Header';
import Scrollbar from '../components/Scrollbars';
import { printDispatchResolutionForm } from './Utils'
import { FieldTeamMemberModal } from "./Modals";
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import ShelterlyPrintifyButton from '../components/ShelterlyPrintifyButton';
import LoadingLink from '../components/LoadingLink';
import ActionsDropdown from '../components/ActionsDropdown';
import { capitalize } from '../utils/formatString';

function DispatchSummary({ id, incident, organization }) {

  const teamNameRef = useRef(null);
  const mapRef = useRef(null);

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const [isLoading, setIsLoading] = useState(true);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const handleCloseRemoveModal = () => setShowRemoveModal(false);
  const [removeSRId, setRemoveSRId] = useState();
  const [removeSRShowId, setRemoveSRShowId] = useState();
  const [species, setSpecies] = useState([]);

  // Initial animal data.
  const [data, setData] = useState({
    id: '',
    closed: false,
    team_members: [],
    team_member_objects: [],
    team: null,
    team_object: {name:''},
    assigned_requests: [],
    dispatch_date: new Date(),
    start_time: null,
    end_time: null,
    bounds:null
  });

  const [mapState, setMapState] = useState({});
  const [collapse, setCollapse] = useState({});
  const [teamData, setTeamData] = useState({teams: [], options: [], isFetching: false});
  const [teamName, setTeamName] = useState('');
  const [defaultTeamName, setDefaultTeamName] = useState(false);
  const [showTeamName, setShowTeamName] = useState(false)
  const handleTeamNameClose = () => {setShowTeamName(false);}
  const [showReopenModal, setShowReopenModal] = useState(false)
  const handleReopenModalClose = () => {setShowReopenModal(false);}
  const [showCloseModal, setShowCloseModal] = useState(false)
  const handleCloseModalClose = () => {setShowCloseModal(false);}
  const [showCaltopoModal, setShowCaltopoModal] = useState(false);
  const [caltopoResults, setCaltopoResults] = useState('');
  const [teamMembers, setTeamMembers] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => {setShow(false);}
  const [showAddTeamMember, setShowAddTeamMember] = useState(false);
  const handleCloseShowAddTeamMember = () => setShowAddTeamMember(false);
  const [teamMemberToDelete, setTeamMemberToDelete] = useState({id: 0, name: '', display_name: ''});
  const [showTeamMemberConfirm, setShowTeamMemberConfirm] = useState(false);
  const handleTeamMemberClose = () => setShowTeamMemberConfirm(false);
  const [error, setError] = useState('');
  const [isPreplanned, setIsPreplanned] = useState(false);
  const priorityText = {1:'Urgent', 2:'High', 3:'Medium', 4:'Low', 5:'Lowest'};
  const [reportedMarkerIcon, setReportedMarkerIcon] = useState(createReportedMarkerIcon(13));
  const [reportedEvacMarkerIcon, setReportedEvacMarkerIcon] = useState(createReportedEvacMarkerIcon(13));
  const [reportedSIPMarkerIcon, setReportedSIPMarkerIcon] = useState(createReportedSIPMarkerIcon(13));
  const [SIPMarkerIcon, setSIPMarkerIcon] = useState(createSIPMarkerIcon(13));
  const [UTLMarkerIcon, setUTLMarkerIcon] = useState(createUTLMarkerIcon(13));
  const [returnRequestedMarkerIcon, setReturnRequestedMarkerIcon] = useState(createReturnRequestedMarkerIcon(13));
  const [checkMarkerIcon, setCheckMarkerIcon] = useState(createCheckMarkerIcon(13));
  const [operationsMarkerIcon, setOperationsMarkerIcon] = useState(createOperationsMarkerIcon(13));

  const handleTeamNameSubmit = async () => {
    let requestBody;

    if (defaultTeamName) {
      requestBody = { defaultName: true };
    } else {
      if (teamName.replace(/ /g, '').length === 0) {
        setError("Team name cannot be blank.");
        return;
      }
      else if (teamName.length > 18) {
        setError("Team name must be 18 characters or less.");
        return;
      }

      requestBody = { name: teamName };
    }

    setIsLoading(true);
    await axios.patch('/evac/api/dispatchteam/' + data.team + '/', requestBody)
    .then(response => {
      setData(prevState => ({ ...prevState, "team_name":teamName }));
      handleTeamNameClose();
      setError('');
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle TeamMember selector onChange.
  const handleChange = (values) => {
    let id_list = [];
    let selected_list = [];
    values.forEach(value => {
      id_list = [...id_list, ...value.id];
      selected_list.push({id:value.id, label:value.label, is_assigned:value.is_assigned})
    });
    setTeamMembers(selected_list);
  }

  const handleGeoJsonDownload = () => {
    var fileDownload = require('js-file-download');
    setIsLoading(true);
    axios.get('/evac/api/evacassignment/' + data.id +'/download/', {
            responseType: 'blob',
        }).then(res => {
            fileDownload(res.data, 'FA-' + id + '.geojson');
        }).catch(err => {
        }).finally(() => setIsLoading(false));
  }

  const handleSRRemove = (sr_id) => {
    axios.get('/hotline/api/servicerequests/' + sr_id + '/remove_active/')
    .then(response => {
      setData(prevState => ({ ...prevState, assigned_requests: data.assigned_requests.filter(ar => ar.service_request !== sr_id) }));
      if (data.assigned_requests.filter(ar => ar.service_request !== sr_id).length === 0) {
        navigate('/' + organization + '/' + incident + '/field');
      }
      else {
        handleCloseRemoveModal();
      }
    })
    .catch(error => {
      setShowSystemError(true);
    })
  }

  const handleGeoJsonPush = () => {
    setIsLoading(true);
    axios.get('/evac/api/evacassignment/' + data.id +'/push/', {
            responseType: 'json',
        }).then(res => {
            setShowCaltopoModal(true); 
            const successfulCount = Object.values(res.data).filter(item => item.status === true).length;
            const totalCount = Object.values(res.data).length;
            setCaltopoResults('Pushed ' + successfulCount + ' out of ' + totalCount +' Service Request(s) successfully.');
        }).catch(err => {
        }).finally(() => setIsLoading(false));
  }

  const handleAddTeamMemberSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/evac/api/dispatchteam/' + data.team + '/', {'dispatch_id':data.id, 'new_team_members':teamMembers.map(item => item.id[0])})
    .then(response => {
      setData(prevState => ({ ...prevState, "team_member_objects":response.data.team_member_objects, "team_members":response.data.team_members, "team_member_names":response.data.display_name }));
      setTeamData(prevState => ({ ...prevState, "options":prevState.options.filter(option => !response.data.team_members.includes(option.id)) }));
      setTeamMembers([]);
      handleClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  const handleRemoveTeamMemberSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/evac/api/dispatchteam/' + data.team + '/', {'remove_team_member':teamMemberToDelete.id})
    .then(response => {
      setData(prevState => ({ ...prevState, "team_member_objects":response.data.team_member_objects, "team_members":response.data.team_members }));
      setTeamData(prevState => ({ ...prevState, "options":prevState.options.concat([{id: [teamMemberToDelete.id], label: teamMemberToDelete.display_name}]) }));
      handleTeamMemberClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  const handleReopenSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/evac/api/evacassignment/'+ data.id + '/', {'closed':false, 'end_time':null})
    .then(response => {
      setData(prevState => ({ ...prevState, "closed":false, "end_time":null }));
      handleReopenModalClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  const handleCloseSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/evac/api/evacassignment/'+ data.id + '/', {'closed':true, 'end_time':new Date()})
    .then(response => {
      setData(prevState => ({ ...prevState, "closed":true, "end_time":response.data.end_time }));
      handleCloseModalClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  const handleDownloadPdfClick = async () => {
    setIsLoading(true);
    // wait for 1 tick so spinner will set before the print button locks up the browser
    await new Promise(resolve => setTimeout(resolve, 0));
    printDispatchResolutionForm({
      drs: [data],
      organization: state.organization.name,
      incident: state.incident.name
    })
      .finally(() => setIsLoading(false));
  }

  // Hook for focusing modal field.
  useEffect(() => {
    if (showTeamName && teamNameRef.current) {
      teamNameRef.current.focus();
    }
  }, [showTeamName]);

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    setIsLoading(true);

    const fetchSpecies = () => {
      // Fetch Species data.
      axios.get('/animals/api/species/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let species_options = [];
          response.data.forEach(result => {
            // Build species option list.
            species_options.push({value: result.name, label: capitalize(result.name)});
          });
          setSpecies(response.data);
          fetchDispatchSummaryData(response.data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    fetchSpecies();

    const fetchDispatchSummaryData = async (species_data) => {
      // Fetch Animal data.
      await axios.get('/evac/api/incident/' + state.incident.id + '/evacassignment/' + id + '/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          const map_dict = {};
          const collapse_dict = {};
          const bounds = [];
          const dupe_bounds = new Set();
          for (const assigned_request of response.data.assigned_requests) {
            const matches = countDictMatches(assigned_request.animals, species_data);
            map_dict[assigned_request.service_request_object.id] = {matches:matches, latitude:assigned_request.service_request_object.latitude, longitude:assigned_request.service_request_object.longitude};
            const key = `${assigned_request.service_request_object.latitude},${assigned_request.service_request_object.longitude}`;
            if (!dupe_bounds.has(key)) {
              dupe_bounds.add(key);
              bounds.push([parseFloat(assigned_request.service_request_object.latitude), parseFloat(assigned_request.service_request_object.longitude)]);
            }
            collapse_dict[String(assigned_request.service_request_object.id)] = true;
          }
          response.data['team_members'] = response.data.team.team_members;
          response.data['team_member_objects'] = response.data.team_object.team_member_objects;
          response.data['bounds'] = bounds.length > 0 ? bounds : L.latLngBounds([[0,0],[0,0]]);
          setCollapse(collapse_dict);
          setData(response.data);
          setMapState(map_dict);
          setTeamData({options: [], isFetching: true});
          setTeamName(response.data.team_name);
          setIsPreplanned(response.data.team_name.match(/^Preplanned [0-9]+$/));
          axios.get('/evac/api/evacteammember/?incident=' + incident + '&organization=' + organization, {
            cancelToken: source.token,
          })
          .then(teamMemberResponse => {
            let options = [];
            // let team_names = [];
            teamMemberResponse.data.filter(team_member => !response.data.team_object.team_members.includes(team_member.id) && team_member.show === true).forEach(function(teammember){
              options.push({id: [teammember.id], label: teammember.display_name, is_assigned:teammember.is_assigned})
            });
            setTeamData({options: options, isFetching: false});
          })
          .catch(error => {
            if (!unmounted) {
              setTeamData({options: [], isFetching: false});
              setShowSystemError(true);
            }
          });
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      })
      .finally(() => setIsLoading(false));
    };

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };

  }, [id, state.incident.id]);

  return (
    <>
    <Header>Field Assignment Summary #{id}</Header>
    <Row className="mb-2">
      <Col>
        <Card className="mb-2 border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-10px"}}>
              <h4 style={{paddingTop:"5px"}}>
                Information
              </h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
              <ActionsDropdown variant="secondary" title="Actions">
                <LoadingLink
                  onClick={() => {setShow(true)}}
                  className="d-block"
                  isLoading={isLoading}
                  label="Add Team Member"
                  disabled={data.end_time}
                  disabled_text="Field Assignment must be open."
                >
                  <FontAwesomeIcon icon={faUserPlus} className="fas" inverse />
                </LoadingLink>
                {data.assigned_requests.filter(assigned_request => !assigned_request.visit_note || !assigned_request.visit_note.date_completed).length === data.assigned_requests.length
                  ? 
                  <LoadingLink
                    href={"/" + organization + "/" + incident + "/field/resolution/" + id}
                    className="d-block"
                    isLoading={isLoading}
                    label="Add Visit Information"
                  >
                    <FontAwesomeIcon icon={faLocationPlus} inverse />
                  </LoadingLink> :
                  <LoadingLink
                    href={"/" + organization + "/" + incident + "/field/resolution/" + id}
                    className="d-block"
                    isLoading={isLoading}
                    label="Update Visit Information"
                    disabled={data.end_time}
                    disabled_text="Field Assignment is closed."
                  >
                    <FontAwesomeIcon icon={faLocationPen} inverse />
                  </LoadingLink>
                }
                {data.end_time ?
                <LoadingLink
                  onClick={() => {setShowReopenModal(true)}}
                  className="d-block"
                  isLoading={isLoading}
                  label="Reopen Field Assignment"
                >
                  <FontAwesomeIcon icon={faClockRotateLeft} className="fas" inverse />
                </LoadingLink>
                :
                <LoadingLink
                  onClick={() => {setShowCloseModal(true)}}
                  className="d-block"
                  isLoading={isLoading}
                  label="Close Field Assignment"
                  disabled={data.assigned_requests.filter(ar => ar.visit_note && ar.visit_note.date_completed).length < data.assigned_requests.length}
                  disabled_text="All Service Requests must have visit information in order to close."
                >
                  <FontAwesomeIcon icon={faClipboardCheck} className="fas fa-move-up" transform={'grow-1'} inverse />
                </LoadingLink>}
                <ShelterlyPrintifyButton
                  id="dispatch-assignment"
                  spinnerSize={2.0}
                  tooltipPlacement='right'
                  label='Download Field Assignment Summary'
                  printFunc={handleDownloadPdfClick}
                  disabled={isLoading}
                  noOverlay={true}
                />
                <LoadingLink
                  onClick={handleGeoJsonDownload}
                  className="d-block"
                  isLoading={isLoading}
                  label="Download Field Assignment as Geojson"
                >
                  <FontAwesomeIcon icon={faFileBracketsCurly} className="fas" inverse />
                </LoadingLink>
                {state.organization.caltopo_enabled ?
                <LoadingLink
                  onClick={handleGeoJsonPush}
                  className="d-block"
                  isLoading={isLoading}
                  label="Push Field Assignment to CalTopo"
                  disabled={state.incident.caltopo_map_id.length == 0}
                  disabled_text="Incident does not have a CalTopo Map associated to it."
                >
                  <FontAwesomeIcon icon={faUpload} className="fas" inverse />
                </LoadingLink>
                : ''}
              </ActionsDropdown>
            )}
            </div>
            <p className="phr"/>
            <Scrollbar no_shadow="true" style={{height:"225px"}} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px", textTransform:"capitalize"}}>
                <ListGroup.Item>
                  <Row>
                    <Col><b>Opened: </b>{<Moment format="MMM Do YYYY, HH:mm">{data.start_time}</Moment>}</Col>
                    <Col><b>Closed: </b>{data.end_time ? <Moment format="MMM Do YYYY">{data.end_time}</Moment> : "N/A"}</Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <b>Team: </b>{data.team_name ? data.team_name : "N/A"}
                      {!data.end_time ? <OverlayTrigger
                        key={"edit-team-name"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-edit-team-name`}>
                            Edit team name
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faPencilAlt} className="ms-1 fa-move-up" size="sm" onClick={() => {setShowTeamName(true);}} style={{cursor:'pointer'}} inverse />
                      </OverlayTrigger> : ""}
                    </Col>
                    {/* <Col>
                      <b>Scheduled: </b>{<Moment format="MMM Do YYYY">{data.dispatch_date || new Date()}</Moment>}
                    </Col> */}
                  </Row>
                </ListGroup.Item>
                {data.team_member_objects && data.team_member_objects.length > 0 && data.team_member_objects.map(team_member => (
                  <ListGroup.Item key={team_member.id}>
                    {team_member.first_name + " " + team_member.last_name}{team_member.agency_id ?
                    <span>&nbsp;({team_member.agency_id})</span> : ""}
                    {team_member.display_phone ?
                    <span>&nbsp;-&nbsp;{team_member.display_phone}</span>
                    : ""}
                    {!data.end_time ? <OverlayTrigger
                      key={"remove-team-member"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-remove-team-member`}>
                          Remove team member
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faMinusSquare} style={{cursor:'pointer'}} size="sm" className="ms-1" onClick={() => {setTeamMemberToDelete({id:team_member.id, name: team_member.first_name + " " + team_member.last_name, display_name: team_member.display_name});setShowTeamMemberConfirm(true);}} inverse />
                    </OverlayTrigger> : ""}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Scrollbar>
          </Card.Body>
        </Card>
      </Col>
      <Col className="border rounded ps-0 pe-0" style={{marginRight:"15px", maxHeight:"320px"}}>
        {!isLoading && data.bounds?.length ? <Map ref={mapRef} className="d-block dispatch-leaflet-container" bounds={data.bounds.length > 1 ? data.bounds : null} center={data.bounds.length === 1 ? [data.bounds[0][0], data.bounds[0][1]] : null} setReportedMarkerIcon={setReportedMarkerIcon} setSIPMarkerIcon={setSIPMarkerIcon} setUTLMarkerIcon={setUTLMarkerIcon} setReturnRequestedMarkerIcon={setReturnRequestedMarkerIcon} setReportedEvacMarkerIcon={setReportedEvacMarkerIcon} setReportedSIPMarkerIcon={setReportedSIPMarkerIcon} setCheckMarkerIcon={setCheckMarkerIcon} setOperationsMarkerIcon={setOperationsMarkerIcon}>
          {data.assigned_requests.map(assigned_request => (
            <Marker
              key={assigned_request.service_request_object.id}
              position={[assigned_request.service_request_object.latitude, assigned_request.service_request_object.longitude]}
              icon={assigned_request.visit_note && assigned_request.visit_note.date_completed ? checkMarkerIcon : assigned_request.service_request_object.reported_animals > 0 ? reportedMarkerIcon : assigned_request.service_request_object.reported_evac > 0 ? reportedEvacMarkerIcon : assigned_request.service_request_object.reported_sheltered_in_place > 0 ? reportedSIPMarkerIcon : assigned_request.service_request_object.sheltered_in_place > 0 ? SIPMarkerIcon : Object.keys(assigned_request.animals).length === 0 ? operationsMarkerIcon : assigned_request.service_request_object.transport_requested > 0 ? returnRequestedMarkerIcon : UTLMarkerIcon}
            >
              <MapTooltip autoPan={false} direction="top">
                <span>
                  SR#{assigned_request.service_request_object.id_for_incident}: {assigned_request.service_request_object.full_address.split(',')[0]}, {assigned_request.service_request_object.full_address.split(',')[1]}
                  <br />
                  {mapState[assigned_request.service_request_object.id] ?
                    <span>
                      {Object.keys(mapState[assigned_request.service_request_object.id].matches).map((key,i) => (
                        <span key={key} style={{textTransform:"capitalize"}}>
                          {i > 0 && ", "}{prettyText(key.split(',')[0], mapState[assigned_request.service_request_object.id].matches[key], species)}
                        </span>
                      ))}
                    </span>
                  :""}
                </span>
              </MapTooltip>
            </Marker>
          ))}
        </Map> : ""}
      </Col>
    </Row>
    {data.assigned_requests.map(assigned_request => (
      <Row key={assigned_request.service_request_object.id} className="ms-0 me-0">
        <Card className="mb-3 border rounded ps-0 pe-0" style={{width:"100%"}}>
          <Card.Body style={{marginBottom:"-3px"}}>
            <Card.Title className="d-flex align-items-start me-0" style={{marginBottom:"-26px"}}>
              <div style={{marginTop:"-4px"}}>
                <h4 className="mb-0 d-inline">
                  {/* {assigned_request.service_request_object.priority === 1 ?
                    <OverlayTrigger
                      key={"highest"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-highest`}>
                          {priorityText[assigned_request.service_request_object.priority]} priority
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faChevronDoubleUp} className="me-1"/>
                    </OverlayTrigger>
                  : assigned_request.service_request_object.priority === 2 ?
                    <OverlayTrigger
                      key={"high"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-high`}>
                          {priorityText[assigned_request.service_request_object.priority]} priority
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faChevronUp} className="me-1"/>
                    </OverlayTrigger>
                  : assigned_request.service_request_object.priority === 3 ?
                    <OverlayTrigger
                      key={"medium"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-medium`}>
                          {priorityText[assigned_request.service_request_object.priority]} priority
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faEquals} className="me-1"/>
                    </OverlayTrigger>
                  : assigned_request.service_request_object.priority === 4 ?
                    <OverlayTrigger
                      key={"low"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-low`}>
                          {priorityText[assigned_request.service_request_object.priority]} priority
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faChevronDown} className="me-1"/>
                    </OverlayTrigger>
                  : assigned_request.service_request_object.priority === 5 ?
                    <OverlayTrigger
                      key={"lowest"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-lowest`}>
                          {priorityText[assigned_request.service_request_object.priority]} priority
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faChevronDoubleDown} className="me-1"/>
                    </OverlayTrigger>
                  : ""} */}
                  SR#{assigned_request.service_request_object.id_for_incident} -&nbsp;
                  <Link href={"/" + organization + "/" + incident + "/hotline/servicerequest/" + assigned_request.service_request_object.id_for_incident} className="text-link me-1" style={{textDecoration:"none", color: "white"}}>{assigned_request.service_request_object.full_address}</Link>            
                  {assigned_request.service_request_object.priority === 1 ?
                    <OverlayTrigger
                      key={"sr-priority"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-sr-priority`}>
                          Priority: Urgent
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faChevronDoubleUp} style={{ color: '#BF1919' }} className="ms-1" />
                    </OverlayTrigger>
                  : ""}
                  {assigned_request.service_request_object.overdue ?
                    <OverlayTrigger
                      key={"sa-overdue"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-sa-overdue`}>
                          Service Request Overdue
                          Follow Up Date: <Moment format="MM/DD/YY">{assigned_request.service_request_object.followup_date}</Moment>
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faCalendarExclamation} style={{ color: '#BF1919' }} className="ms-1" />
                    </OverlayTrigger>
                  : ""}
                  &nbsp;
                  {collapse[String(assigned_request.service_request_object.id)] ? <FontAwesomeIcon icon={faChevronCircleDown} onClick={() => {setCollapse(prevState => ({ ...prevState, [String(assigned_request.service_request_object.id)]:false}))}} className="" style={{cursor:"pointer"}} size="sm" /> : <FontAwesomeIcon icon={faChevronCircleUp} onClick={() => {setCollapse(prevState => ({ ...prevState, [String(assigned_request.service_request_object.id)]:true}))}} className="" style={{cursor:"pointer"}} size="sm" />}
                  &nbsp;
                  </h4>
                </div>
                <Col className="float-end" style={{marginTop:"-8px"}}>
                {isLoading ? (
                  <Spinner
                    className="align-self-center me-3"
                    {...{
                      as: 'span',
                      animation: 'border',
                      size: undefined,
                      role: 'status',
                      'aria-hidden': 'true',
                      variant: 'light',
                      style: {
                        height: '1.5rem',
                        width: '1.5rem',
                        marginBottom: '0.75rem'
                      }
                    }}
                  />
                ) : (
                  <ActionsDropdown variant="secondary" title="Actions" className="float-end">
                    {!assigned_request.visit_note || !assigned_request.visit_note.date_completed
                      ? 
                      <LoadingLink
                        href={"/" + organization + "/" + incident + "/field/resolution/" + id + "/request/" + assigned_request.service_request_object.id}
                        className="d-block"
                        isLoading={isLoading}
                        label="Add Visit Information"
                      >
                        <FontAwesomeIcon icon={faLocationPlus} inverse />
                      </LoadingLink> :
                      <LoadingLink
                        href={"/" + organization + "/" + incident + "/field/resolution/" + id + "/request/" + assigned_request.service_request_object.id}
                        className="d-block"
                        isLoading={isLoading}
                        label="Update Visit Information"
                        disabled={data.end_time}
                        disabled_text="Field Assignment is closed."
                      >
                        <FontAwesomeIcon icon={faLocationPen} inverse />
                      </LoadingLink>
                    }
                    <LoadingLink
                      href={"/" + organization + "/" + incident + "/hotline/servicerequest/edit/" + assigned_request.service_request_object.id_for_incident}
                      isLoading={isLoading}
                      className="d-block"
                      label="Update Service Request"
                    >
                      <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                    </LoadingLink>
                    <LoadingLink
                      href={"/" + organization + "/" + incident + "/hotline/servicerequest/" + assigned_request.service_request_object.id_for_incident + "/assign"}
                      isLoading={isLoading}
                      className="d-block"
                      label="Reassign Service Request to FA"
                      disabled={data.end_time || (assigned_request.visit_note && assigned_request.visit_note.date_completed)}
                      disabled_text={data.end_time ? "Field Assignment is closed." : "Visit Information has already been added to this Field Assignment."}
                    >
                      <FontAwesomeIcon icon={faMapMarkedAlt} className="fas" inverse />
                    </LoadingLink>
                    <LoadingLink
                      onClick={() => {
                        setRemoveSRId(assigned_request.service_request_object.id);
                        setRemoveSRShowId(assigned_request.service_request_object.id_for_incident)
                        setShowRemoveModal(true);
                      }}
                      isLoading={isLoading}
                      className="d-block"
                      label="Remove Service Request from FA"
                      disabled={data.end_time || (assigned_request.visit_note && assigned_request.visit_note.date_completed)}
                      disabled_text={data.end_time ? "Field Assignment is closed." : "Visit Information has already been added to this Field Assignment."}
                    >
                      <FontAwesomeIcon icon={faLocationXmark} className="fas" inverse />
                    </LoadingLink>
                  </ActionsDropdown>
                )}
                </Col>
                <span className="float-end" style={{marginTop:"-16px", marginRight:"-22px"}}>
                  {assigned_request.visit_note && assigned_request.visit_note.date_completed ?
                    <OverlayTrigger
                      key={"request-complete"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-request-complete`}>
                          Service Request visit has been marked as completed.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faCheckSquare} size="4x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    :
                    <OverlayTrigger
                      key={"request-pending"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-request-pending`}>
                          Service Request visit information is still pending.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faSquareExclamation} size="4x" className="ms-1 treatment-icon" style={{marginTop:"-13px", marginRight:"-3px"}} transform={'shrink-2'} inverse />
                    </OverlayTrigger>
                    }
                  </span>
            </Card.Title>
            <Collapse in={!collapse[String(assigned_request.service_request_object.id)]}>
            <span>
            <p className="phr" style={{marginBottom:"7px"}}/>
              <ListGroup variant="flush" style={{marginTop:"-5px", marginBottom:"7px"}}>
                <ListGroup.Item>
                  <Row>
                    <Col xs={3}>
                      <b>Priority: </b>{priorityText[assigned_request.service_request_object.priority]}
                    </Col>
                    <Col xs={3}>
                      <b>Followup Date: </b>
                        {assigned_request.service_request_object.followup_date ? <Moment format="MM/DD/YY">{assigned_request.service_request_object.followup_date}</Moment> : "N/A"}
                    </Col>
                    <Col xs={3}>
                      <b>Completed Date: </b>{assigned_request.visit_note && assigned_request.visit_note.date_completed ? <Moment format="MM/DD/YY">{assigned_request.visit_note.date_completed}</Moment> : "N/A"}
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Row>
                    <Col xs={3}>
                      <b>Forced Entry: </b>{assigned_request.visit_note && assigned_request.visit_note.forced_entry ? "Yes" : "No"}
                    </Col>
                    <Col xs={3}>
                      <b>Latitude: </b>{assigned_request.service_request_object.latitude}
                    </Col>
                    <Col xs={3}>
                      <b>Longitude: </b>{assigned_request.service_request_object.longitude}
                    </Col>
                  </Row>
                </ListGroup.Item>
                {assigned_request.service_request_object.owner_objects.map(owner => (
                  <ListGroup.Item key={owner.id}>
                    <b>Owner: </b><Link href={"/" + organization + "/" + incident + "/people/owner/" + owner.id} className="text-link" style={{textDecoration:"none", color:"white"}}>{owner.first_name} {owner.last_name}</Link>
                    {owner.display_phone ? <span>&nbsp;{owner.display_phone}</span>: ""}
                    {owner.email ?
                    <OverlayTrigger
                      key={"owner-email"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-owner-email`}>
                          Email: {owner.email}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faEnvelope} className="ms-1" inverse />
                    </OverlayTrigger>
                    : ""}
                    {/* {assigned_request.owner_contact ?
                    <span>
                      {assigned_request.owner_contact.owner_name === owner.first_name + ' ' + owner.last_name ?
                      <OverlayTrigger
                        key={"owner-contacted"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-owner-contacted`}>
                            Contacted: {assigned_request.owner_contact.owner_contact_time ? <Moment format="l HH:mm">{assigned_request.owner_contact.owner_contact_time}</Moment> : 'N/A'}
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faUserCheck} className="ms-1 fa-move-up" size="sm" inverse />
                      </OverlayTrigger> : ""}
                      <div style={{whiteSpace:"pre-line"}}><b>Contact Note: </b>{assigned_request.owner_contact.owner_contact_note}</div>
                    </span>
                    : ""} */}
                  </ListGroup.Item>
                ))}
              {assigned_request.service_request_object.owner_objects.length ?
                <ListGroup.Item>
                  <div className="mt-1 mb-0"><b>Owner Notified of Outcome: </b>{assigned_request.owner_contacted ? "Yes" : "No"}</div>
                </ListGroup.Item>
              :""}
              {assigned_request.service_request_object.reporter_object ? 
                <ListGroup.Item>
                  <b>Reporter: </b>{assigned_request.service_request_object.reporter_object.first_name + " " + assigned_request.service_request_object.reporter_object.last_name}
                  {assigned_request.service_request_object.reporter_object.agency ? <span className="ms-1">({assigned_request.service_request_object.reporter_object.agency})</span> : "" }
                  {assigned_request.service_request_object.reporter_object.display_phone ?<span>&nbsp;{assigned_request.service_request_object.reporter_object.display_phone}</span>: ""}
                </ListGroup.Item> : ""}
              <ListGroup.Item><b>Instructions for Field Team:</b> {assigned_request.service_request_object.directions||"No instructions available."}</ListGroup.Item>
            </ListGroup>
            {assigned_request.service_request_object.animals.length ? <p className="phr" style={{marginTop:"5px"}}/> : ""}
            {assigned_request.service_request_object.animals.length ? <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-4px"}}>
              <h5 className="mt-2" style={{marginBottom:"-2px"}}>Animals</h5>
              {assigned_request.service_request_object.animals.filter(animal => Object.keys(assigned_request.animals).includes(String(animal.id))).map((animal, inception) => (
                <ListGroup.Item key={animal.id}>
                  <span style={{textTransform:"capitalize"}}><Link href={"/" + organization + "/" + incident + "/animals/" + animal.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>
                    A#{animal.id_for_incident}</Link> - {animal.animal_count > 1 ? <span>{animal.animal_count} {animal.species_string}</span> : <span>{animal.name||"Unknown Name"}&nbsp;-&nbsp;{animal.species_string}</span>}</span>
                  {animal.color_notes ?
                    <OverlayTrigger
                      key={"animal-color-notes"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-animal-color-notes`}>
                          {animal.color_notes}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faClipboardList} className="ms-1" size="sm" inverse />
                    </OverlayTrigger>
                  : ""}
                  {animal.behavior_notes ?
                    <OverlayTrigger
                      key={"animal-behavior-notes"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-animal-behavior-notes`}>
                          {animal.behavior_notes}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faExclamationSquare} className="ms-1 fa-move-down" size="sm" inverse />
                    </OverlayTrigger>
                  : ""}
                  {animal.medical_notes ?
                    <OverlayTrigger
                      key={"animal-medical-notes"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-animal-medical-notes`}>
                          {animal.medical_notes}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faBriefcaseMedical} className="ms-1" size="sm" inverse />
                    </OverlayTrigger>
                  : ""}
                  {assigned_request.animals[animal.id].is_new ?
                    <OverlayTrigger
                      key={"animal-is-new"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-animal-is-new`}>
                          This animal was added to the Service Request while it was already assigned to this active Field Assignment.
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faSparkles} className="ms-1" size="sm" inverse />
                    </OverlayTrigger>
                  : ""}
                  {animal.pcolor || animal.scolor ? <span className="ms-1" style={{textTransform:"capitalize"}}>({animal.pcolor ? animal.pcolor : "" }{animal.scolor ? <span>{animal.pcolor ? <span>/</span> : ""}{animal.scolor}</span> : ""})</span>: ""}
                  &nbsp;- {animal.status}
                </ListGroup.Item>
              ))}
            </ListGroup> : ""}
            {assigned_request.service_request_object.notes.filter(note => note.urgent === true).length ? <span>
              <p className="phr" style={{marginTop:"5px"}}/>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-4px"}}>
                <h5 className="mt-2" style={{marginBottom:"-2px"}}>Shared Service Request Notes</h5>
                  {assigned_request.service_request_object.notes.filter(note => note.urgent === true).map(note =>
                  <ListGroup.Item key={note.id} style={{whiteSpace:"pre-line"}}>
                    {note.notes || "No information available."}
                  </ListGroup.Item>
                  )}
              </ListGroup>
            </span> : ""}
            {assigned_request.visit_note ?
            <span>
              <p className="phr" style={{marginTop:"5px"}}/>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-4px"}}>
                <h5 className="mt-2" style={{marginBottom:"-2px"}}>Visit Notes</h5>
                  <ListGroup.Item style={{whiteSpace:"pre-line"}}>
                    {assigned_request.visit_note.notes || "No information available."}
                  </ListGroup.Item>
              </ListGroup>
            </span>
            : ""}
            {assigned_request.service_request_object.visit_notes.length > 0 ? <p className="phr" style={{marginTop:"5px"}}/> : ""}
            {assigned_request.service_request_object.visit_notes.length > 0 ? <h5 className="mt-2" style={{marginBottom:"-2px"}}>Previous Visit Notes</h5> : ""}
            <ListGroup variant="flush" style={{marginBottom:"-13px"}}>
            {assigned_request.service_request_object.visit_notes.map(visit_note =>
              <ListGroup.Item key={visit_note.id} style={{whiteSpace:"pre-line"}}>
                <Link href={"/" + organization + "/" + incident + "/field/assignment/note/" + visit_note.id} className="text-link" style={{textDecoration:"none", color:"white"}}><Moment format="L">{visit_note.date_completed}</Moment></Link>: {visit_note.notes || "No information available."}
              </ListGroup.Item>
            ) || "None"}
            </ListGroup>
            </span>
          </Collapse>
        </Card.Body>
      </Card>
    </Row>
    ))}
    <Modal show={showTeamName} onHide={handleTeamNameClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Team Name</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label className="mb-2">Team Name</label>
        <BootstrapForm.Control
          id="team_name"
          name="team_name"
          type="text"
          ref={teamNameRef}
          onChange={(event) => {setTeamName(event.target.value);}}
          value={teamName}
          disabled={defaultTeamName}
        />
        {error ? <div style={{ color: "#e74c3c", fontSize: "80%" }}>{error}</div> : ""}
      </Modal.Body>
      <Modal.Footer>
        {!isLoading && isPreplanned ? (
          <BootstrapForm.Check
            id="defaultNameCheck"
            type="checkbox"
            style={{ flexGrow: 1 }}
            label="Use Default Team Name"
            onChange={() => setDefaultTeamName(!defaultTeamName)}
            checked={defaultTeamName}
          />
        ) : null}
        
        <Button variant="primary" onClick={handleTeamNameSubmit}>Save</Button>
        <Button variant="secondary" onClick={handleTeamNameClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Team Members</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label className="mb-2">Use Existing Team Members</label>
        <Row>
          <Col>
            <Typeahead
              id="team_members"
              multiple
              onChange={(values) => {handleChange(values)}}
              selected={teamMembers}
              options={teamData.options}
              placeholder="Choose team members..."
              renderMenuItemChildren={(option) => (
                <div>
                  {option.label} {option.is_assigned ? <FontAwesomeIcon icon={faExclamationTriangle} size="sm" /> : ""}
                </div>
              )}
            />
          </Col>
          <Col className="pe-0" style={{maxWidth:"33px", paddingLeft:"0px", marginLeft:"-13px", marginRight:"18px", marginTop:"-1px"}}>
            <OverlayTrigger
              key={"add-team-member"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-add-team-member`}>
                  Add a new team member
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faPlusSquare} className="" size="3x" transform="shrink-1 up-1" onClick={() => setShowAddTeamMember(true)} style={{cursor:"pointer"}} inverse />
            </OverlayTrigger>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleAddTeamMemberSubmit}>Add</Button>
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <FieldTeamMemberModal state={state} selected={teamMembers} setSelected={setTeamMembers} handleCloseShowAddTeamMember={handleCloseShowAddTeamMember} setShowSystemError={setShowSystemError} showAddTeamMember={showAddTeamMember} />
    {/* <Formik
          initialValues={{
            first_name: '',
            last_name: '',
            phone: '',
            agency_id: '',
            incident: state ? state.incident.id : 'undefined',
            organization: state ? state.organization.id : 'undefined',
          }}
          enableReinitialize={true}
          validationSchema={Yup.object({
            first_name: Yup.string()
              .max(50, 'Must be 50 characters or less')
              .required('Required'),
            last_name: Yup.string()
              .max(50, 'Must be 50 characters or less')
              .required('Required'),
            phone: Yup.string()
              .matches(phoneRegex, "Phone number is not valid")
              .required('Required'),
            agency_id: Yup.string()
              .max(20, 'Must be 20 characters or less'),
          })}
          onSubmit={(values, { resetForm, setFieldValue }) => {
            axios.post('/evac/api/evacteammember/', values)
            .then(response => {
              let selected_list = [...teamMembers];
              selected_list.push({id:[response.data.id], label:response.data.first_name + " " + response.data.last_name + (response.data.agency_id ? " (" + response.data.agency_id + ")" : ""), is_assigned:true})
              setTeamMembers(selected_list);
              handleCloseShowAddTeamMember();
              resetForm();
            })
            .catch(error => {
              setShowSystemError(true);
            });
          }}
        >
          {formikProps => (
            <Modal show={showAddTeamMember} onHide={handleCloseShowAddTeamMember}>
              <Modal.Header closeButton>
                <Modal.Title>Add New Team Member</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <BootstrapForm>
                  <Row className="gx-2">
                    <TextInput
                      type="text"
                      label="First Name*"
                      name="first_name"
                      id="first_name"
                      xs="6"
                    />
                    <TextInput
                      type="text"
                      label="Last Name*"
                      name="last_name"
                      id="last_name"
                      xs="6"
                    />
                  </Row>
                  <Row className="mt-3 gx-2">
                    <TextInput
                      type="text"
                      label="Phone*"
                      name="phone"
                      id="phone"
                      xs="6"
                    />
                    <TextInput
                      type="text"
                      label="Agency ID"
                      name="agency_id"
                      id="agency_id"
                      xs="6"
                    />
                  </Row>
                </BootstrapForm>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => formikProps.submitForm()}>Save</Button>
                <Button variant="secondary" onClick={handleCloseShowAddTeamMember}>Close</Button>
              </Modal.Footer>
            </Modal>
          )}
        </Formik> */}
    <Modal show={showTeamMemberConfirm} onHide={handleTeamMemberClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Team Member Removal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you would like to remove team member {teamMemberToDelete.name} from this field assignment?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleRemoveTeamMemberSubmit}>Yes</Button>
        <Button variant="secondary" onClick={handleTeamMemberClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showReopenModal} onHide={handleReopenModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Field Assignment Reopen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you would like to reopen this field assignment?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleReopenSubmit}>Yes</Button>
        <Button variant="secondary" onClick={handleReopenModalClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showCloseModal} onHide={handleCloseModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Field Assignment Close</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{marginBottom:"-5px"}}>
          Are you sure you are ready to close this field assignment?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleCloseSubmit}>Yes</Button>
        <Button variant="secondary" onClick={handleCloseModalClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showRemoveModal} onHide={handleCloseRemoveModal}>
      <Modal.Header closeButton>
        <Modal.Title>Remove SR from Active Field Assignment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you would like to remove SR#{removeSRShowId} from this active field assignment?
        <br /><br />
        {data.assigned_requests.length === 1 ? <p> Removing the last Service Request will automatically close this Field Assignment.</p> : ""}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {handleSRRemove(removeSRId);}}>Yes</Button>
        <Button variant="secondary" onClick={handleCloseRemoveModal}>No</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showCaltopoModal} onHide={() => setShowCaltopoModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>CalTopo Results</Modal.Title>
      </Modal.Header>
      <Modal.Body>{ caltopoResults }</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowCaltopoModal(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default DispatchSummary;
